"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDetailedResult = exports.pruneDetailedResults = void 0;
function pruneDetailedResults(executionResults) {
    var prunedExecutionResults = [];
    executionResults.forEach(function (er) {
        if (er.evaluatedResource) {
            delete er.evaluatedResource;
        }
        if (er.detailedResults) {
            var prunedDetailedResults = er.detailedResults.map(function (dr) {
                return __assign(__assign(__assign({ groupId: dr.groupId }, (dr.populationResults ? { populationResults: dr.populationResults } : {})), (dr.episodeResults ? { episodeResults: dr.episodeResults } : {})), (dr.stratifierResults ? { stratifierResults: dr.stratifierResults } : {}));
            });
            var newEr = __assign(__assign({}, er), { detailedResults: prunedDetailedResults });
            prunedExecutionResults.push(newEr);
        }
        else {
            // If detailed results don't exist, there's nothing to prune.
            // we can pass through a casted version of `er`
            prunedExecutionResults.push(er);
        }
    });
    return prunedExecutionResults;
}
exports.pruneDetailedResults = pruneDetailedResults;
function isDetailedResult(result) {
    var candidate = result;
    return (candidate.html != null ||
        candidate.populationRelevance != null ||
        candidate.clauseResults != null ||
        candidate.statementResults != null);
}
exports.isDetailedResult = isDetailedResult;
//# sourceMappingURL=DetailedResultsHelpers.js.map